import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 px-4 md:px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=soft%20romantic%20gradient%20background%20with%20warm%20rose%20and%20cream%20tones%2C%20delicate%20cherry%20blossom%20petals%20floating%2C%20dreamy%20atmospheric%20texture%2C%20minimalist%20elegant%20composition%2C%20artistic%20abstract%20photography&width=1600&height=700&seq=cta-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-black/40"></div>
      </div>

      <div className="relative z-10 max-w-[1280px] mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl text-background-50 mb-4">
          与佐佐木明希一起，开启精彩旅程
        </h2>
        <p className="text-background-50/80 text-sm md:text-base max-w-xl mx-auto mb-8 leading-relaxed">
          关注官方社交媒体账号，第一时间获取佐佐木明希最新动态、活动信息与独家内容
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/news"
            className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            浏览最新动态
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-full bg-background-50/15 text-background-50 font-medium text-sm hover:bg-background-50/25 backdrop-blur-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解佐佐木明希
          </Link>
        </div>
      </div>
    </section>
  );
}